import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import WOW from 'wowjs';

export const NosotrosPage = () => {

    const { t, i18n } = useTranslation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        new WOW.WOW().init();
    }, []);

    return (
        <>
            <section id="nosotros">
                <div className="hero-section position-relative banner-section gap-2">
                    <img className="icon wow fadeInUp" src="/assets/img/new/elemento.png" />
                    <h1 className="wow fadeInUp">{t("us")}</h1>
                    <img className="icon wow fadeInUp" src="/assets/img/new/elemento2.png" />
                </div>
            </section>
            <section id="conoce" className="section">
                <div className="grid-section">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5 ps-lg-5 order-md-2">
                                <h1 className="title-section mb-4 wow fadeIn">{t("knowCompany")}</h1>
                                <p className="text-section mb-4 wow fadeInDown" style={{ textAlign: "justify" }} >{t("companyDescription1")}</p>
                                <p className="text-section mb-4 wow fadeInDown" style={{ textAlign: "justify" }} >{t("companyDescription2")}</p>
                                <p className="text-section mb-4 wow fadeInDown" style={{ textAlign: "justify" }} >{t("companyDescription3")}</p>
                                {/* <div className="d-flex align-items-center mb-2 wow fadeIn">
                                    <div className="me-2">
                                        <img className="icon" src="assets/img/new/elemento.png" style={{ width: "30px" }} />
                                    </div>
                                    <p className="text-section">{t("knowCompanyItem1")}</p>
                                </div>
                                <div className="d-flex align-items-center mb-2 wow fadeIn">
                                    <div className="me-2">
                                        <img className="icon" src="assets/img/new/elemento.png" style={{ width: "30px" }} />
                                    </div>
                                    <p className="text-section">{t("knowCompanyItem2")}</p>
                                </div>
                                <div className="d-flex align-items-center mb-2 wow fadeIn">
                                    <div className="me-2">
                                        <img className="icon" src="assets/img/new/elemento.png" style={{ width: "30px" }} />
                                    </div>
                                    <p className="text-section">{t("knowCompanyItem3")}</p>
                                </div>
                                <div className="d-flex align-items-center mb-2 wow fadeIn">
                                    <div className="me-2">
                                        <img className="icon" src="assets/img/new/elemento.png" style={{ width: "30px" }} />
                                    </div>
                                    <p className="text-section">{t("knowCompanyItem4")}</p>
                                </div>
                                <div className="d-flex align-items-center mb-2 wow fadeIn">
                                    <div className="me-2">
                                        <img className="icon" src="assets/img/new/elemento.png" style={{ width: "30px" }} />
                                    </div>
                                    <p className="text-section">{t("knowCompanyItem5")}</p>
                                </div>
                                <div className="d-flex align-items-center mb-2 wow fadeIn">
                                    <div className="me-2">
                                        <img className="icon" src="assets/img/new/elemento.png" style={{ width: "30px" }} />
                                    </div>
                                    <p className="text-section">{t("knowCompanyItem6")}</p>
                                </div> */}
                            </div>
                            <div className="col-lg-7 mb-5 mb-lg-0 order-md-1">
                                <div className="imgs-grid">
                                    <div className="grid grid-1 wow bounceInDown" data-wow-duration="1s" data-wow-delay="0.1s"><img src="/assets/img/sections/nuestra-empresa1.jpeg" className="shadow-default" alt="Agroesana uva" /></div>
                                    <div className="grid grid-2 wow bounceInDown" data-wow-duration="1.3s" data-wow-delay="0.2s"><img src="/assets/img/sections/nuestra-empresa2.jpeg" className="shadow-default" alt="Agroesana surcos" /></div>
                                    <div className="grid grid-3 wow bounceInDown" data-wow-duration="1.5s" data-wow-delay="0.1s"><img src="/assets/img/sections/nuestra-empresa3.jpeg" className="shadow-default" alt="Agroesana siembra" /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="mision" className="section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5 ps-lg-5">
                            <h1 className="title-section mb-4 wow fadeIn">{t("mission")}</h1>
                            <p className="text-section mb-4 wow fadeInDown" style={{ textAlign: "justify" }} >{t("missionDescription")}</p>
                        </div>
                        <div className="col-lg-7 mb-5 d-flex justify-content-center">
                            <img className="rounded-2 shadow-default wow bounceInDown" src="/assets/img/sections/mision.jpg" style={{ width: "80%" }} alt="Mision agroesana" />
                        </div>
                    </div>
                </div>
            </section>
            <section id="mision" className="section">
                <div className="container">
                    <div className="row align-items-center align-content-center">
                        <div className="col-lg-5 ps-lg-5 order-md-2">
                            <h1 className="title-section mb-4 wow fadeIn">{t("vision")}</h1>
                            <p className="text-section mb-4 wow fadeInDown" style={{ textAlign: "justify" }} >{t("visionDescription")}</p>
                        </div>
                        <div className="col-lg-7 mb-5 d-flex justify-content-center order-md-1">
                            <img className="rounded-2 shadow-default wow bounceInDown" src="/assets/img/sections/vision.jpeg" style={{ width: "80%" }} alt="Vision agroesana" />
                        </div>
                        
                    </div>
                </div>
            </section>

        </>
    );
}